import React, { useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

const playerStyle = {
  border: '0',
  marginTop: '8px',
};

function VideoPlayer({ videoID }) {
  const iframeRef = useRef(null);

  useLayoutEffect(() => {
    const width = iframeRef.current.clientWidth;
    iframeRef.current.height = width * 0.6;
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="Youtube player"
      width="100%"
      src={`https://youtube.com/embed/${videoID}?autoplay=0`}
      allowFullScreen="allowfullscreen"
      style={playerStyle}
    />
  );
}

VideoPlayer.propTypes = {
  videoID: PropTypes.string.isRequired,
};

export default React.memo(VideoPlayer);
